export const isLegacyChat = (slug?: string) => {
  return (
    !!slug &&
    (slug.startsWith('pm-') ||
      slug.startsWith('chat-') ||
      slug.startsWith('private-'))
  )
}
